import { useCallback, useState } from "react";
import { useNavigate } from "react-router";
import { api } from "../../../api";
import { Button } from "../../../externalComponents/tailwind/button";
import {
  Dialog,
  DialogActions,
  DialogBody,
  DialogTitle,
} from "../../../externalComponents/tailwind/dialog";
import ErrorModal from "../../../externalComponents/ErrorModal";

const DialogDuplicate = ({ customerId, listData, setListData }) => {
  const { selectedCampaign, isModalDuplicateOpen, isDuplicateLoading } =
    listData;
  const navigate = useNavigate();
  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);

  const updateIsDuplicateLoading = useCallback((isDuplicateLoading) => {
    setListData((_listData) => ({
      ..._listData,
      isDuplicateLoading,
    }));
  }, []);

  const closeModal = useCallback(() => {
    if (!isDuplicateLoading) {
      setListData((_listData) => ({
        ..._listData,
        isModalDuplicateOpen: false,
      }));
    }
  }, [isDuplicateLoading]);

  const handleDuplicateConfirmation = async () => {
    updateIsDuplicateLoading(true);
    try {
      const newCampaign = await api.duplicateCampaignNodesAndEdges({
        oldCampaignId: listData.selectedCampaign.id,
        customerId,
      });
      navigate(`/automations/edit/${newCampaign.id}`);
    } catch {
      setListData((_listData) => ({
        ..._listData,
        isModalDuplicateOpen: false,
      }));
      setIsErrorModalOpen(true);
    } finally {
      updateIsDuplicateLoading(false);
    }
  };

  const handleErrorModalClose = () => {
    setIsErrorModalOpen(false);
    setListData((_listData) => ({
      ..._listData,
      isModalDuplicateOpen: false,
    }));
  };

  return (
    <>
      <Dialog
        key="dialog_duplicate"
        open={isModalDuplicateOpen}
        onClose={closeModal}
      >
        <DialogTitle close={!isDuplicateLoading}>
          Duplicate this automation{" "}
        </DialogTitle>
        <DialogBody className="flex-1 overflow-y-auto scrollbar">
          <p>
            Are you sure you want to duplicate the automation{" "}
            <b>{selectedCampaign?.name}</b>?
          </p>
        </DialogBody>
        <DialogActions>
          <Button
            color="secondaryButton"
            onClick={closeModal}
            disabled={isDuplicateLoading}
            className="min-w-[100px] h-10"
          >
            Cancel
          </Button>
          <Button
            color="primaryButton"
            onClick={() => handleDuplicateConfirmation(selectedCampaign)}
            className="min-w-[100px] h-10"
            loading={isDuplicateLoading}
          >
            Duplicate
          </Button>
        </DialogActions>
      </Dialog>

      <ErrorModal
        open={isErrorModalOpen}
        onClose={handleErrorModalClose}
        errorType={"duplicate"}
      />
    </>
  );
};

export default DialogDuplicate;
